import { Phone } from './phone.model';
import { Office } from './office.model';
import { ID } from './ID.model';
import { CategoryV2 } from '../components/generics/data-printer-v2/data-printer-v2.component';

export interface Broker {
    activo?: boolean;
    apellido: string;
    celular: Phone;
    email: string;
    fechaActualizacion?: string;
    fechaCreacion?: string;
    id?: ID;
    nombre: string;
    oficina: Office;
    cuit: string;
    clave?: string;
}

export function generateBrokerCategories(broker?: Broker) {
    if (!broker) return [];

    const categories: CategoryV2[] = [];

    categories.push({
        items: [
            { label: 'Nombre', value: `${ broker.nombre } ${ broker.apellido }` },
        ]
    }, {
        items: [
            { label: 'CUIT', value: broker.cuit, type: 'cuit' },
        ]
    }, {
        items: [
            { label: 'Email', value: broker.email, type: 'email' },
        ]
    }, {
        items: [
            { label: 'Teléfono', value: broker.celular, type: 'phone' },
        ]
    });

    return categories;
}
